module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/scales-blue-dark-tile.0484915.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/scales-blue-dark-tile.jpg
// module id = XRbJ
// module chunks = 0